import { Link } from 'react-router-dom'
import {ArrowLeft, Construction} from 'lucide-react'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

interface ComingSoonProps {
  title: string
  description: string
}

function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex flex-1 items-center justify-center px-4 py-24">
        <div className="max-w-md text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-600">
            <Construction size={26} />
          </div>
          <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
          <p className="mt-3 text-base leading-relaxed text-slate-600">{description}</p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 rounded-lg bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
          >
            <ArrowLeft size={16} /> Volver al inicio
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default ComingSoon
